import { isEmpty } from 'lodash';
import helper from '../../preorder/api/helper';
import config from '../../preorder/configs/config';

const API_ENDPOINT = `${config.API_ENDPOINT}/externalApi-menuCommand`;
const DEFAULT_QUERY = {
  env: process.env.REACT_APP_MODE,
};

export const checkout = ({
  couponVoucherId,
  items,
  paymentInfo,
  paymentMethod,
  token,
}) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    command: 'preOrderCheckout',
    couponVoucherId,
    items,
    paymentInfo,
    paymentMethod,
    token,
  },
});

export const fetchData = ({ query }) => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    ...query,
  },
});

export const checkCouponsDiscount = ({ token, items }) => {
  if (isEmpty(items)) throw new Error('missing parameter items');
  if (isEmpty(token)) throw new Error('missing parameter token');

  return helper.post({
    url: API_ENDPOINT,
    query: {
      ...DEFAULT_QUERY,
    },
    body: {
      command: 'checkCouponsDiscount',
      items,
      token,
    },
  });
};

export const checkShopCampaignDiscount = ({ token, items }) => {
  if (isEmpty(items)) throw new Error('missing parameter items');
  if (isEmpty(token)) throw new Error('missing parameter token');

  return helper.post({
    url: API_ENDPOINT,
    query: {
      ...DEFAULT_QUERY,
    },
    body: {
      command: 'checkShopCampaignDiscount',
      items,
      token,
    },
  });
};
